'use client'

import { forwardRef } from 'react'
import { FloatingTree, useFloatingParentNodeId } from '@floating-ui/react'
import { MenuComponent } from './menu-component'
import { MenuComponentProps } from './utils'

export const DropdownMenu = forwardRef<HTMLButtonElement, MenuComponentProps>((props, ref) => {
  const parentId = useFloatingParentNodeId()

  if (parentId === null) {
    return (
      <FloatingTree>
        <MenuComponent {...props} ref={ref} />
      </FloatingTree>
    )
  }

  return <MenuComponent {...props} ref={ref} />
})

DropdownMenu.displayName = 'DropdownMenu'
